import * as ServerOperations from "@/Common/Operations/operations.server";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RequestMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { IReportingModel } from "../Models/UI/IReportingModel";
import { ReportingAction } from "./Actions/ReportingActions";
import { ReportingHandler } from "./Handlers/Local/ReportingHandler";
import { ReportingMiscHandler } from "./Handlers/Local/ReportingMiscHandler";

let defaultInstance: ReportingStore;

class ReportingStore extends BaseStore {
    public ReportingActions: ReportingAction;
    public ReportingModel: IReportingModel;
    public defaultsLoaded: boolean;

    private Mapper: RequestMapper;
    private ReportingHandler: ReportingHandler;
    private ReportingMiscHandler: ReportingMiscHandler;

    constructor() {
        super();

        var self = this;

        this.defaultsLoaded = false;
        this.Mapper = new RequestMapper();

        this.ReportingActions = new ReportingAction();

        this.ReportingHandler = new ReportingHandler();
        this.ReportingMiscHandler = new ReportingMiscHandler();

        this.Mapper.AddInstance(this.ReportingHandler);
        this.Mapper.AddInstance(this.ReportingMiscHandler);

        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => self.Mapper.Map(request, self));

        this.ServerDispatchToken = ServerResponseDispatcher.register((response: ServerEvent) => {
            var fireEmit = true;
            var self = this;

            switch (response.Operation) {
                case ServerOperations.Server.Myle_Reporting_Sisense_SSO:

                    this.ReportingModel = this.ReportingModel.set("JWTToken", response.Data["JWTToken"]);
                    this.ReportingModel = this.ReportingModel.set("MainReportingURL", response.Data["MainUrl"]);
                    this.ReportingModel = this.ReportingModel.set("MainReportingDashboardURL", response.Data["DashboardUrl"]);
                    this.ReportingModel = this.ReportingModel.set("User", response.Data["User"]);
                    this.ReportingModel = this.ReportingModel.set("IsAuthenticated", true);

                    break;

                default:
                    fireEmit = false;
                    break;
            }

            if (fireEmit) self.EmitChangeToListeners();
        });

        var defaultReportingModel = {
            JWTToken: "",
            MainReportingURL: "",
            MainReportingDashboardURL: "",
            IsAuthenticated: false
        };
        this.ReportingModel = Immutable.fromJS(defaultReportingModel);
    }

    public static createSingleton(): ReportingStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new ReportingStore());
    }

    public static createSingletonFrom(store: ReportingStore, copy: boolean = true): ReportingStore {
        return copy
            ? Object.assign(this.createSingleton(), store)
            : this.createStoreSingleton(defaultInstance, () => defaultInstance = store);
    }
}

export { ReportingStore, defaultInstance as reportingStore };
